import {register} from '@shopify/theme-sections';
import Swiper from 'swiper';

const selectors = {
  target: '.testimonials__slider--',
  thumbs: '.testimonials__thumbs--',
};

register('testimonials', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const targetGallery = `${selectors.target}${id}`;
    const targetThumbs = `${selectors.thumbs}${id}`;
    const targetSelector = document.querySelector(targetGallery);
    const targetThumbsSelector = document.querySelector(targetThumbs);

    if (!targetSelector) { return; }

    const blockCount = targetThumbsSelector.dataset.blockCount;

    const swiperThumbs = new Swiper(targetThumbs, {
      spaceBetween: 10,
      slidesPerView: blockCount,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      fadeEffect: {
        crossFade: true,
      },
    });

    const swiper = new Swiper(targetGallery, {
      slidesPerView: 1,
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      thumbs: {
        swiper: swiperThumbs
      }
    });
  },

  onBlockSelect: (blockId) => {
    const id = blockId.detail.sectionId;
    const currentSlide = parseInt(blockId.target.dataset.swiperSlideIndex) + 1;
    const target = `${selectors.target}${id}`;
    const swiper = document.querySelector(target).swiper;
    swiper.slideTo(currentSlide, 1000, false);

    console.log(`🤠 Slide to block ${currentSlide}`)
  },
});
